import React, { PropsWithChildren, ReactNode } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const BLOCK_NAME = 'Page-layout';
const cn = classnames.bind(styles);

type TProps = PropsWithChildren & {
  categoryTree?: ReactNode;
};

export const PageLayout = ({ children, categoryTree }: TProps) => {
  return (
    <div
      className={cn(BLOCK_NAME, {
        [`${BLOCK_NAME}--single-column`]: !categoryTree,
      })}
    >
      {categoryTree}
      {children}
    </div>
  );
};
